import { render, staticRenderFns } from "./ChatOrderPanel.vue?vue&type=template&id=8647ff96&scoped=true&"
import script from "./ChatOrderPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderPanel.vue?vue&type=style&index=0&id=8647ff96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8647ff96",
  null
  
)

export default component.exports